import {request} from "../shared/httpInterceptor";
import {useCountryLang} from "./useCountryLang";
import {useQuery} from "@tanstack/react-query";
import {IFooterData} from "../interfaces/IFooterData";

export const fetchFooterData = async (countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/template/footer`,
    method: 'get',
    host: host
  };

  // Only add context and cookies if they exist
  if (context?.req?.cookies) {
    requestConfig.cookies = context.req.cookies;
  }
  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

export const useFooterData = () => {
  const countryLang = useCountryLang()

  return useQuery<IFooterData>(["footer-data", countryLang], () => fetchFooterData(countryLang), {
    enabled: countryLang != null,
  })
}
